var actions, initialState;

actions = require('../actions/cards');

initialState = {
  isFetching: false,
  didInvalidate: false,
  items: {}
};

module.exports = function(state, action) {
  if (state == null) {
    state = initialState;
  }
  switch (action.type) {
    case actions.INVALIDATE_CARDS:
      return Object.assign({}, state, {
        didInvalidate: true
      });
    case actions.REQUEST_CARDS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case actions.RECEIVE_CARDS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.cards,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/reducers/cards.coffee
 ** module id = 281
 ** module chunks = 0
 **/